jQuery(document).ready(function ($) {
    togglePaginationVisibility(0);
    if($('.vt-slide').length){
        $('.vt-slide__inside').each(function(){
            if($(this).parent().hasClass('active')) {
                $(this).parent().css({'opacity': '1'})
                return false;
            }
        });
    }
    $('#vt-start').on('click',function(){
        $('#vt-next').click();
    });
    $('#vt-pagin-next, #vt-next').on('click',function(e) {
        e.preventDefault();
        togglePaginationVisibility(curIndex + 1);
        if ($(this).hasClass('disabled')) return;

        let curIndex = parseInt($('.vt-slide.next-card').attr('data-index'));
        if(isNaN(curIndex) || curIndex>0){
            $('#vt-pagin-prev, #vt-previous, #vt-pagin-restart').removeClass('disabled')
        }

        $('.vt-slide.prev-card, #vt-previous').removeClass('prev-card');
        $('.vt-slide.active').removeClass('active').addClass('prev-card').css({'opacity': '0'});
        if($('.vt-slide.next-card').hasClass('end')){
            $('#vt-pagin-next, #vt-next').addClass('disabled');
        }
        let displayedSlideNumber = curIndex;
        if (curIndex === 0) {
            displayedSlideNumber = 1;
        }
        $('.vt-pagination__prev-next>span').text(Math.min(displayedSlideNumber, ($('.vt-slide').length - 1)) + ' of ' + ($('.vt-slide').length - 1));

        $('.vt-slide.next-card').removeClass('next-card').addClass('active').css({'opacity': '1'});
        $('.vt-slide[data-index="' + (curIndex + 1) + '"]').removeClass('prev-card').addClass('next-card');
        togglePaginationVisibility(curIndex + 1);
    });
    $('#vt-pagin-prev, #vt-previous').on('click', function (e) {
        e.preventDefault();
        if ($(this).hasClass('disabled')) return;

        let newIndex = parseInt($('.vt-slide.prev-card').attr('data-index'));

        $('#vt-pagin-next, #vt-next').removeClass('disabled')
        $('.vt-slide.next-card').removeClass('next-card');
        $('.vt-slide.active').removeClass('active').addClass('next-card').css({ 'opacity': '0' });
        if (newIndex == 0) {
            $('#vt-pagin-prev, #vt-previous, #vt-pagin-restart').addClass('disabled');
        }

        $('.vt-slide.prev-card').css({ 'opacity': '1' }).removeClass('prev-card').addClass('active');
        $('.vt-slide[data-index="' + (newIndex - 1) + '"]').removeClass('next-card').addClass('prev-card');
        $('.vt-pagination__prev-next>span').text(Math.max(newIndex, 0) + ' of ' + ($('.vt-slide').length - 1));

        // Add the function call to update the visibility of the pagination
        togglePaginationVisibility(newIndex);
    });

    let startPos = {x:0,y:0};
    let swipeThreshold = 30;
    let swipeVerticalThreshold = 100;
    $('.vt-slides').on('touchstart', function(e){
        startPos.x = e.originalEvent.touches[0].screenX;
        startPos.y = e.originalEvent.touches[0].screenY;
    });
    $('.vt-slides').on('touchend', function(e){
        console.log(Math.abs(startPos.y - e.originalEvent.changedTouches[0].screenY))
        if( Math.abs(startPos.x - e.originalEvent.changedTouches[0].screenX) >= swipeThreshold && Math.abs(startPos.y - e.originalEvent.changedTouches[0].screenY) <= swipeVerticalThreshold){
            const dir = startPos.x - e.originalEvent.changedTouches[0].screenX > 0 ? 'left' : 'right';
            if (dir == "left") {
                $('#vt-pagin-next').trigger('click')
            }
            if (dir == "right") {
                $('#vt-pagin-prev').trigger('click')
            }
            e.stopImmediatePropagation();
            e.preventDefault();
        }
    });

    $('#vt-pagin-restart, #vt-end-restart').on('click',function(e){
        e.preventDefault();
        $('.vt-slide').each(function (index){
            $(this).removeClass('next-card').removeClass('prev-card').removeClass('active').css({'opacity': '0'})
            if(index===0){
                $(this).addClass('active').css({'opacity': '1'});
            }else if(index===1){
                $(this).addClass('next-card');
            }

        });
        $('#vt-pagin-prev, #vt-previous, #vt-pagin-restart').addClass('disabled');
        $('#vt-pagin-next, #vt-next').removeClass('disabled');
        $('.vt-pagination__prev-next>span').text('0 of ' + ($('.vt-slide').length - 1));

        togglePaginationVisibility(0);
    })

    if($('#vt-controls').length){
        $( 'body' ).keydown(function(e) {
            if(e.keyCode === 39){
                $('#vt-pagin-next').click();
            }else if(e.keyCode === 37){
                $('#vt-pagin-prev').click();
            }
        });
    }
    $('.note-bubble--navigate').on('click',markNavigationInstruction);
    function markNavigationInstruction()
    {
        $('.note-bubble--navigate').hide();
        $.post(accountingcoach.ajax_url +'?action=ac_navigation_instruction_viewed').then(function(res){

        }).catch(function(e){})
    }
    $('.note-bubble--study').on('click',markStudyInstruction);
    function markStudyInstruction()
    {
        $('.note-bubble--study').hide();
        $.post(accountingcoach.ajax_url +'?action=ac_study_instruction_viewed').then(function(res){

        }).catch(function(e){})
    }
    /* Study Mode */

    $('body').on('click', '#vt-study-control span', function(e) {
        var $span = $(this);
        var spanId = $span.attr('id');
        if($span.hasClass('active')) {
            e.preventDefault();
        }
        else if (spanId === 'vt-study-on') {
            $('.hero, header, .lightgrey-bg, .download-author, .upgrade-to-proplus, .publications, #lower-promo, #footer, #mark-complete, #topic-outline-mini, #footer-search, .achievements').css({'opacity' : 0, 'pointer-events' : 'none'}).hide();
            $('#vt-study-control span').removeClass('active');
            $span.addClass('active');
        }
        else if (spanId === 'vt-study-off') {
            $('#vt-study-control span').removeClass('active');
            $('.hero, header, .lightgrey-bg, .download-author, .upgrade-to-proplus, .publications, #lower-promo, #footer, #mark-complete, #topic-outline-mini, #footer-search, .achievements').css({'opacity' : 1, 'pointer-events' : 'auto'}).show();
            $span.addClass('active');
        }
    });

    function togglePaginationVisibility(slideIndex) {
        if (slideIndex === 0) {
            $('.vt-pagination__prev-next').css('display', 'none');
        } else {
            $('.vt-pagination__prev-next').css('display', 'flex');
        }
    }

    /* Close note bubble */

    // $('.note-bubble').each(function() {
    //     $(this).on('click', function() {
    //         $(this).fadeOut(200);
    //         var action = $(this).hasClass('note-bubble--study') ? 'mark_user_tutorial_study_mode_instruction_viewed' : 'mark_user_tutorial_navigate_instruction_viewed';
    //         $.ajax({
    //             url: ajaxurl,
    //             type: "POST",
    //             data: {
    //                 action: action
    //             },
    //             dataType: "json"
    //         });
    //     });
    // });

});

